import React from 'react';
import AceEditor from 'react-ace';


import "ace-builds/src-noconflict/ace";
import "ace-builds/src-noconflict/mode-html";
import "ace-builds/src-noconflict/mode-jsp";
import "ace-builds/src-noconflict/mode-javascript";
import "ace-builds/src-noconflict/ext-language_tools";
import "ace-builds/src-noconflict/ext-beautify";
import "ace-builds/src-noconflict/theme-monokai";
import "ace-builds/src-noconflict/ext-searchbox";

// import 'brace/mode/html';
// import 'brace/mode/jsp';
// import 'brace/ext/beautify';
// import 'brace/snippets/html';
// import 'brace/theme/monokai';
// import 'brace/ext/searchbox';
// import 'brace/mode/javascript';
// import 'brace/ext/language_tools';
// import 'brace/snippets/javascript';

import { Button } from '@mui/material';

export default class CodeEditor extends React.Component {
  state = {
    value: '',
  };

  UNSAFE_componentWillMount() {
    this.setState({ value: this.props.value });
  }

  render() {
    const { mode, width, height, onSaveBtnClick } = this.props;
    const { value } = this.state;

    return (
      <div>
        <AceEditor
          mode={mode}
          fontSize={14}
          theme="monokai"
          showGutter={true}
          name="code-editor"
          style={{ marginBottom: '20px' }}
          value={value || ''}
          showPrintMargin={true}
          width={width || '100%'}
          highlightActiveLine={true}
          placeholder="// Start typing code"
          onChange={(value) => this.setState({ value })}
          height={height || 'calc(100vh - 40px)'}
          enableLiveAutocompletion={true}
          setOptions={{
            tabSize: 2,
            enableSnippets: true,
            showLineNumbers: true,
            enableLiveAutocompletion: true,
            enableBasicAutocompletion: true,
          }}
        />

        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
          }}
        >
          <Button size="small" variant="contained" color="primary" onClick={() => onSaveBtnClick(value)}>
            Save
          </Button>
        </div>
      </div>
    );
  }
}
